import useTemplateVariables from 'components/domain/customData/useTemplateVariables';
import { RichTextEditorToolbarPluginProps } from 'components/editor/RichTextEditor.types';
import { SystemTemplates } from 'models/automation/SystemTemplates';
import { SYSTEM_TEMPLATE_VARIABLES } from 'pages/automations/systemTemplates/SystemTemplatesTab.constants';

interface UseSystemTemplateToolbarSettingsProps {
  key: SystemTemplates;
  loadPreview: (content: string) => Promise<string>;
  onEnterPreviewMode: () => void;
  onExitPreviewMode: () => void;
}

const useSystemTemplateToolbarSettings = ({
  key,
  loadPreview,
  onEnterPreviewMode,
  onExitPreviewMode,
}: UseSystemTemplateToolbarSettingsProps) => {
  const { variables, isLoading: isLoadingVariables } = useTemplateVariables(
    SYSTEM_TEMPLATE_VARIABLES[key],
  );

  const toolbarSettings: RichTextEditorToolbarPluginProps['toolbarSettings'] = {
    enabled: true,
    features: {
      bold: true,
      cleanHTML: true,
      editHTML: true,
      fontFamily: true,
      italic: true,
      link: true,
      lists: true,
      preview: {
        loadPreview,
        onEnterPreviewMode,
        onExitPreviewMode,
      },
      quote: true,
      textAlignment: true,
      textColor: true,
      underline: true,
      variables,
    },
  };

  return {
    toolbarSettings,
    isLoadingVariables,
  };
};

export default useSystemTemplateToolbarSettings;
